import {
  IExtractorVendorMappingContact,
  IExtractorVendorMappingFormContact,
} from 'companySettings/types';

// Single-line label for the contact SELECTED in the drawer's autocomplete — the input holds one
// line. The dropdown rows and the table cells break the same data onto several lines.
export const getContactLabel = (contact?: IExtractorVendorMappingFormContact | null): string => {
  if (!contact) {
    return '';
  }

  return [contact.name, contact.companyName && `(${contact.companyName})`]
    .filter(Boolean)
    .join(' ');
};

// Only an explicit `null` means "this contact lost its corporate user". A contact just picked from
// the autocomplete carries no `corporateUserId` at all, and it is resolvable by construction.
export const isContactUnresolved = (
  contact?: IExtractorVendorMappingContact | IExtractorVendorMappingFormContact | null
): boolean => Boolean(contact) && null === contact.corporateUserId;
